/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect } from "react";
import "./calendar-input.scss";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { pl } from "date-fns/locale";
import moment from "moment";
import { registerLocale } from "react-datepicker";
import { Button } from "components";

interface CalendarInputProps {
  label?: string;
  type: string;
  inputOnFocus?: any;
  maxLength?: number;
  minDate?: any;
  maxDate?: any;
  withHours?: boolean;
  size?: "large" | "small" | "medium";

  // formik;
  field: any;
  errors: any;
  form: any;
  touched?: any;
  onChange?: (data: string) => void;
  handleOnChange?: any;
  isOnBlurAction: boolean;
  onFocus: any;
  onBlur?: any;
}

const customPlLocale = {
  ...pl,
  localize: {
    ...pl.localize,
    day: (n: any, options: any) => {
      const dayNames = ["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "Sb"];
      return dayNames[n];
    },
  },
};
registerLocale("custom-pl", customPlLocale);

const CalendarInput = ({
  label,
  errors = {},
  form,
  field,
  type,
  inputOnFocus,
  onBlur,
  maxLength,
  onChange,
  minDate,
  maxDate,
  withHours = false,
  size = "large",
}: CalendarInputProps) => {
  const parseDate = (value: string | null) => {
    if (value) {
      const date = moment(value, "DD/MM/yyyy HH:mm").toDate();
      return date;
    }
    return null;
  };

  const inputRef = useRef<HTMLInputElement>(null);
  const calendarRef = useRef<HTMLDivElement>(null);
  const [startDate, setStartDate] = useState(parseDate(field?.value));
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  const handleSetTime = () =>
    withHours && field.value && field.value.split(" ");
  const [time, setTime] = useState(withHours && field?.value ? "" : "00:00");

  useEffect(() => {
    if (withHours) {
      handleSetTime()[1] && setTime(handleSetTime()[1].slice(0, 5));
    }
  }, [withHours]);

  useEffect(() => {
    if (minDate) {
      const dateStartStr = form.values.dateStart;
      const dateEndStr = form.values.dateEnd;

      const dateStart = moment(dateStartStr, "DD/MM/YYYY HH:mm:ss");
      const dateEnd = moment(dateEndStr, "DD/MM/YYYY HH:mm:ss");

      if (dateEnd.isSameOrBefore(dateStart)) {
        const newDateEnd = dateStart.add(1, "minute");
        form.values.dateEnd = newDateEnd.format("DD/MM/YYYY HH:mm:ss");
        setStartDate(parseDate(newDateEnd.format("DD/MM/YYYY HH:mm:ss")));
        const newDate = newDateEnd.format("DD/MM/YYYY HH:mm:ss").split(" ");
        setTime(newDate[1].slice(0, 5));
      }
      // if (withHours && time.length >= 5) {
      //   const newDate = field.value.split(" ");
      //   setTime(newDate[1].slice(0, 5));
      //   setStartDate(parseDate(field.value));
      // }
    }
  }, [time, field.value]);

  const handleConfirmDate = () => {
    setIsDatePickerOpen(false);
    setStartDate(startDate || minDate);
    withHours && form.setFieldValue(field.name, startDate);

    if (startDate) {
      form.setFieldValue(
        field.name,
        startDate && withHours
          ? moment(startDate).format("DD/MM/YYYY HH:mm")
          : moment(startDate).format("DD/MM/YYYY")
      );
    } else if (minDate) {
      form.setFieldValue(field.name, moment(minDate).format("DD/MM/YYYY"));
    }

    onChange && onChange(moment(startDate).format("DD/MM/YYYY"));
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [time]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target as Node) &&
        isDatePickerOpen
      ) {
        setIsDatePickerOpen(false);
        setStartDate(parseDate(field.value));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDatePickerOpen]);

  const handleCloseDate = () => {
    setStartDate(parseDate(field.value));
    setIsDatePickerOpen(false);
    setTime(handleSetTime()[1].slice(0, 5));
  };

  const ExampleCustomTimeInput = () => {
    const handleChangeTime = (e: React.ChangeEvent<HTMLInputElement>) => {
      let cursorPosition = e.target.selectionStart || 0;
      let inputValue = e.target.value;
      inputValue = inputValue.replace(/[^0-9:]/g, "");

      if (inputValue.length === 2 && !inputValue.includes(":")) {
        inputValue += ":";
      }

      const [hours, minutes] = inputValue.split(":");
      if (parseInt(hours) > 23) inputValue = "23:" + (minutes || "00");
      if (parseInt(minutes) > 59) inputValue = hours + ":59";

      setTime(inputValue);

      setTimeout(() => {
        if (inputRef.current) {
          if (cursorPosition === 2) cursorPosition++;
          inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
        }
      }, 0);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      let cursorPosition = e.currentTarget.selectionStart || 0;
      const isDigit = /^\d$/.test(e.key);
      const isBackspace = e.key === "Backspace";

      if (isDigit) {
        let newValue = time.split("");
        if (cursorPosition === 0) {
          if (parseInt(e.key) > 2) {
            newValue[0] = "2";
          } else {
            newValue[0] = e.key;
          }
          if (newValue[0] === "2") {
            setTimeout(() => {
              if (inputRef.current) {
                inputRef.current.setSelectionRange(1, 1);
              }
            }, 0);
          }
        } else if (cursorPosition === 1) {
          if (newValue[0] === "2") {
            if (parseInt(e.key) > 3) {
              newValue[1] = "3";
            } else {
              newValue[1] = e.key;
            }
          } else {
            newValue[1] = e.key;
          }
          if (!newValue.includes(":")) {
            newValue.splice(2, 0, ":");
            cursorPosition++;
          }
        } else if (cursorPosition === 3) {
          if (parseInt(e.key) > 5) {
            newValue[3] = "5";
          } else {
            newValue[3] = e.key;
          }
        } else if (cursorPosition === 4) {
          newValue[4] = e.key;
        }
        setTime(newValue.join(""));

        setTimeout(() => {
          if (inputRef.current) {
            cursorPosition++;
            if (cursorPosition === 2) cursorPosition++;
            inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
          }
        }, 0);
        e.preventDefault();
      }

      if (isBackspace && cursorPosition > 0) {
        let newValue = time.split("");
        if (cursorPosition === 4) {
          newValue[3] = "0";
        } else if (cursorPosition === 3) {
          newValue[1] = "0";
        } else if (cursorPosition === 1) {
          newValue[0] = "0";
        }
        setTime(newValue.join(""));

        setTimeout(() => {
          if (inputRef.current) {
            cursorPosition--;
            if (cursorPosition === 2) cursorPosition--;
            inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
          }
        }, 0);
        e.preventDefault();
      }
    };

    const handleOnBlur = (e: any) => {
      let inputValue = e.target.value;
      if (inputValue.length === 5) {
        const hours = parseInt(inputValue.slice(0, 2), 10);
        const minutes = parseInt(inputValue.slice(3, 5), 10);

        if (!isNaN(hours) && !isNaN(minutes)) {
          const newDate = new Date(startDate || new Date());
          newDate.setHours(hours);
          newDate.setMinutes(minutes);
          setStartDate(newDate);
        }
      }
    };

    return (
      <input
        ref={inputRef}
        maxLength={5}
        pattern="[0-9]{0,2}:[0-5][0-9]"
        value={time}
        onBlur={handleOnBlur}
        onChange={(e: any) => handleChangeTime(e)}
        onKeyDown={(e: any) => handleKeyDown(e)}
      />
    );
  };

  return (
    <div className="calendar-input__wrapper" ref={calendarRef}>
      <div className="calendar-input__content">
        {label && <label className="calendar-input__label">{label}</label>}
        <div
          className={`calendar-input__icon ${
            size ? `calendar-input__icon--${size}` : ""
          }`}
          onClick={() => setIsDatePickerOpen(true)}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z"
              stroke="#096EB5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div onClick={() => !isDatePickerOpen && setIsDatePickerOpen(true)}>
          <DatePicker
            className={`${size ? `react-datepicker__input--${size}` : ""}`}
            readOnly
            showTimeInput={withHours}
            timeInputLabel="Godzina:"
            locale="custom-pl"
            selected={startDate}
            minDate={minDate}
            maxDate={maxDate}
            dateFormat={`${withHours ? "dd/MM/YYYY HH:mm" : "dd/MM/YYYY"}`}
            customTimeInput={<ExampleCustomTimeInput />}
            shouldCloseOnSelect={false}
            open={isDatePickerOpen}
            onChange={(date: any) => {
              setStartDate(date);
            }}
            renderCustomHeader={({
              monthDate,
              decreaseMonth,
              increaseMonth,
            }) => {
              return (
                <div className="react-datepicker__custom-head">
                  <button
                    type="button"
                    aria-label="Previous Month"
                    className={
                      "react-datepicker__navigation react-datepicker__navigation--previous"
                    }
                    onClick={decreaseMonth}
                  >
                    <span
                      className={
                        "react-datepicker__navigation-icon react-datepicker__navigation-icon--previous"
                      }
                    >
                      {"<"}
                    </span>
                  </button>
                  <span className="react-datepicker__current-month">
                    {monthDate.toLocaleString("pl", {
                      month: "long",
                    })}
                  </span>
                  <button
                    aria-label="Next Month"
                    type="button"
                    className={
                      "react-datepicker__navigation react-datepicker__navigation--next"
                    }
                    onClick={increaseMonth}
                  >
                    <span
                      className={
                        "react-datepicker__navigation-icon react-datepicker__navigation-icon--next"
                      }
                    >
                      {">"}
                    </span>
                  </button>
                </div>
              );
            }}
          >
            <div className="react-datepicker__buttons">
              <Button
                size="medium"
                onClick={() => {
                  handleCloseDate();
                }}
                stroke
                label="Anuluj"
              />
              <Button
                size="medium"
                label="Potwierdź"
                onClick={() => handleConfirmDate()}
              />
            </div>
          </DatePicker>
        </div>
      </div>
      {errors && form.touched && (
        <div className="calendar-input__error">
          {form.touched[field.name] && <span>{errors[field.name]}</span>}
        </div>
      )}
    </div>
  );
};

export default CalendarInput;
